import { useCallback, useState } from "react";

export function useClipboard(timeoutMs = 1500): {
  copy: (text: string) => Promise<boolean>;
  copied: boolean;
} {
  const [copied, setCopied] = useState(false);
  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), timeoutMs);
      return true;
    } catch {
      return false;
    }
  }, [timeoutMs]);
  return { copy, copied };
}
